import React from "react";
import {useSelector,useDispatch} from 'react-redux'
import axios from 'axios'
import {useState} from 'react'
import gif from './loading.gif'



function Plan (props){
    const data = useSelector(state => state.news)
    const dispatch = useDispatch()
    const [load,setLoad] = useState(false)
    
    
    function getData (){
        axios.get(`/?id=WIrbis&action=Conference/GetPlan&sid=${props.sid}`).then((resp) => {
          dispatch ({type:'TABLE_LOAD_NEWS',payload1: resp.data})
    
          setLoad(true)
      })
      }

      if (load === false){
        return (<div className='loading'><img onLoad={getData()} src={gif} width='100' height='100'/> </div>)
     } else{
    return(
        <div>
        <img className="map" src={`/?id=0&idm=General&ida=GetSidFileWeb&sid=${props.sid}&fname=placemap`} />
        <div className="section">
          <div className="heading">
              <h3>Аудитории</h3>
          </div>
          <div className="heading-info">
              {
                data.map((place) =>{
                    return(
                        <table key={place.code}>
                        <tbody>
                        <tr >
                            <td>{place.code}</td>
                            <td>{place.title}</td>
                            <td>{place.description}</td>
                        </tr>
                        </tbody>
                        </table>
                    )
                })
              }
          </div>
    </div>
    </div>
    )}



}



export default Plan